import moduleRoutes from "../../../routes/moduleRouteList";
import PageRouterList from "../../../routes/routeList";

const base = (window as any)._env_?.BASE_URL;

export const RECEPTION_TABS = {
  appointments: "1",
  encounters: "2",
  registrations: "3",
} as const;

export type ReceptionTab =
  (typeof RECEPTION_TABS)[keyof typeof RECEPTION_TABS];

export const getReceptionPath = (tab?: ReceptionTab): string => {
  const path = `${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${PageRouterList.reception}`;
  return tab ? `${path}?tab=${tab}` : path;
};
